export enum MutationKeys {
  feedGeneration = 'feedGeneration',
  transactionEvent = 'transactionEvent',
}
